import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { AddressFields } from "../../../../../components/guardian/ManualEntryFields";

/** Home-address entry block for historic guardian attorney sections. */
export default function AttorneyHomeAddressFields({
  index,
  keys,
  guardian,
  guardians,
  gVal,
  loadingCitiesStates,
  allCities,
  allStates,
  GoogleAutoComplete,
  LabeledCreatableSelect,
  googlePlaceholder,
  streetTextFieldProps,
  zipTextFieldProps,
  data,
  updateData,
  handleGoogleCallback,
  handleZipCodeChange,
}) {
  const mergeGuardians = (next) => updateData({ ...data, guardians: next });

  return (
    <Box className="grid grid-cols-1 gap-4">
      <AddressFields
        address={gVal(guardian, keys, "address")}
        zipCode={gVal(guardian, keys, "zip")}
        city={gVal(guardian, keys, "city")}
        state={gVal(guardian, keys, "state")}
        googlePlaceholder={googlePlaceholder}
        onAddressChange={(val) => {
          const ug = [...guardians];
          ug[index] = { ...ug[index], [keys.address]: val };
          mergeGuardians(ug);
        }}
        onZipChange={(e) => handleZipCodeChange(e, index)}
        onCityChange={(val) => {
          const ug = [...guardians];
          ug[index] = { ...ug[index], [keys.city]: val };
          mergeGuardians(ug);
        }}
        onStateChange={(val) => {
          const ug = [...guardians];
          ug[index] = { ...ug[index], [keys.state]: val };
          mergeGuardians(ug);
        }}
        onGoogleCallback={(address, city, state, zipCode) =>
          handleGoogleCallback(index, address, city, state, zipCode)
        }
        loading={loadingCitiesStates}
        allCities={allCities}
        allStates={allStates}
        GoogleAutoComplete={GoogleAutoComplete}
        LabeledCreatableSelect={LabeledCreatableSelect}
        streetTextFieldProps={streetTextFieldProps}
        zipTextFieldProps={zipTextFieldProps}
      />
    </Box>
  );
}

AttorneyHomeAddressFields.propTypes = {
  index: PropTypes.number.isRequired,
  keys: PropTypes.object.isRequired,
  guardian: PropTypes.object.isRequired,
  guardians: PropTypes.array.isRequired,
  gVal: PropTypes.func.isRequired,
  loadingCitiesStates: PropTypes.bool,
  allCities: PropTypes.array.isRequired,
  allStates: PropTypes.array.isRequired,
  GoogleAutoComplete: PropTypes.elementType.isRequired,
  LabeledCreatableSelect: PropTypes.elementType.isRequired,
  googlePlaceholder: PropTypes.string.isRequired,
  streetTextFieldProps: PropTypes.object,
  zipTextFieldProps: PropTypes.object,
  data: PropTypes.object.isRequired,
  updateData: PropTypes.func.isRequired,
  handleGoogleCallback: PropTypes.func.isRequired,
  handleZipCodeChange: PropTypes.func.isRequired,
};
